import { render, staticRenderFns } from "./FlowVersionList.vue?vue&type=template&id=4041d72f&scoped=true&"
import script from "./FlowVersionList.vue?vue&type=script&lang=js&"
export * from "./FlowVersionList.vue?vue&type=script&lang=js&"
import style0 from "./FlowVersionList.vue?vue&type=style&index=0&id=4041d72f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4041d72f",
  null
  
)

export default component.exports